var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":_vm.width,"height":_vm.height,"viewBox":"0 0 55 55","preserveAspectRatio":"none"}},[_c('desc',[_vm._v(_vm._s(_vm.iconName))]),_c('g',{attrs:{"fill":_vm.iconColor}},[_c(_vm.svgIcon,{tag:"component"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }